var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tooltipContent",staticClass:"tooltip",class:{
        'nowrap' : _vm.enabledIfTruncated,
        'is-disabled' : _vm.disabled
    },on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.hideTooltip}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }